import { requestErrorInterceptor, requestInterceptor, responseInterceptor, responseErrorInterceptor } from './utils';
import { buildQueryString } from '../utils/common';
import axios from 'axios';
import config from './../../config.json';

export const getAxiosClient = (baseDns) =>
  axios.create({
    baseURL: baseDns,
    maxBodyLength: 100000000,
    maxContentLength: 10000000,
    paramsSerializer: buildQueryString,
    withCredentials: true,
  });

const aiApiClient = getAxiosClient(config.ONEDOC_AI_URL + '/v1');
aiApiClient.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
aiApiClient.interceptors.response.use(responseInterceptor, responseErrorInterceptor);

export default aiApiClient;

export const fetchApiQuery = async ({ url, method = 'GET', data, params }) => {
  try {
    const result = await aiApiClient({
      url,
      method,
      data,
      params,
    });
    return { data: result };
  } catch (axiosError) {
    let err = axiosError.response ? axiosError.response : axiosError;
    return {
      error: {
        status: err.status || 'FETCH_ERROR',
        data: err.data || err.message,
      },
    };
  }
};
